module.exports = __webpack_public_path__ + "static/media/BIM 360 Docs.3de55853.png";